import { useParams } from "react-router-dom";
import { m } from "framer-motion";
import { Col } from "react-bootstrap";
import InteractiveBanners03 from "../../Components/InteractiveBanners/InteractiveBanners03";
import { fadeIn } from "../../Functions/GlobalAnimations";
import { useQuery } from "@tanstack/react-query";
import {
  getAgriBusinessPartner,
  getFarmers,
  getFPOFPC,
  getMSME,
  getStartup,
  getTechnicalOfficer,
} from "../../Store/Publication/beneficiaryCorner";
import Loading from "../../Components/Loading";
const BeneficiaryCornerDetailed = () => {
  const { name } = useParams();

  const heading =
    name === "farmer"
      ? "Farmer"
      : name === "fpo-fpc"
      ? "FPC"
      : name === "agri-business-partner"
      ? "Agri Business Partner"
      : name === "msme"
      ? "MSME"
      : name === "startup"
      ? "Startup"
      : name === "subject-matter-specialist" && "Subject Matter Specialist";

  const { data: FarmersData, isLoading: isLoadingFarmers } = useQuery({
    queryKey: ["FarmersData"],
    queryFn: () => getFarmers(),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: name === "farmer",
  });
  const { data: FPOFPCData, isLoading: isLoadingFPOFPC } = useQuery({
    queryKey: ["FPOFPCData"],
    queryFn: () => getFPOFPC(),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: name === "fpo-fpc",
  });
  const {
    data: AgriBusinessPartnerData,
    isLoading: isLoadingAgriBusinessPartner,
  } = useQuery({
    queryKey: ["AgriBusinessPartnerData"],
    queryFn: () => getAgriBusinessPartner(),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: name === "agri-business-partner",
  });
  const { data: MSMEData, isLoading: isLoadingMSME } = useQuery({
    queryKey: ["MSMEData"],
    queryFn: () => getMSME(),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: name === "msme",
  });
  const { data: StartupData, isLoading: isLoadingStartup } = useQuery({
    queryKey: ["StartupData"],
    queryFn: () => getStartup(),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: name === "startup",
  });
  const { data: TechnicalOfficerData, isLoading: isLoadingTechnicalOfficer } =
    useQuery({
      queryKey: ["TechnicalOfficerData"],
      queryFn: () => getTechnicalOfficer(),
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      enabled: name === "subject-matter-specialist",
    });

  if (
    isLoadingFarmers ||
    isLoadingAgriBusinessPartner ||
    isLoadingFPOFPC ||
    isLoadingTechnicalOfficer ||
    isLoadingStartup ||
    isLoadingMSME
  )
    return <Loading />;

  return (
    <>
      <m.div className="container  mt-[200px] mb-[50px] ">
        <Col xl={8} lg={10} className="text-center w-fit">
          <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">
            {heading}
          </h3>
          <m.div
            className="border-b border-1 w-[40%] border-[#146084]"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          />
        </Col>

        <section>
          <div className="mt-[70px]">
            <InteractiveBanners03
              link={true}
              grid="row-cols-1 gap-y-10"
              overlay={["#0000004a", "#0000004a"]}
              data={
                name === "farmer"
                  ? FarmersData?.data
                  : name === "fpo-fpc"
                  ? FPOFPCData?.data
                  : name === "agri-business-partner"
                  ? AgriBusinessPartnerData.data
                  : name === "startup"
                  ? StartupData?.data
                  : name === "msme"
                  ? MSMEData?.data
                  : name === "subject-matter-specialist" &&
                    TechnicalOfficerData?.data
              }
              animation={fadeIn}
            />
          </div>
        </section>
      </m.div>
    </>
  );
};

export default BeneficiaryCornerDetailed;
